import { Button, Tag } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import type { EntitySummary } from '@/api/types';
import { EntityStatusChip } from './chips';

/** Compact entity identity card — reused in the work-item drawer and (as a fallback) elsewhere. */
export function EntitySummaryCard({
  summary,
  onOpen,
}: {
  summary: EntitySummary;
  onOpen?: () => void;
}) {
  return (
    <div className="ol-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 13.5 }}>{summary.typeKey ?? 'Entity'}</div>
          <div className="ol-mono" style={{ fontSize: 11, color: 'var(--ol-text-tertiary)', wordBreak: 'break-all' }}>
            {summary.entityId}
          </div>
        </div>
        {onOpen && (
          <Button size="small" icon={<ArrowRightOutlined />} onClick={onOpen}>
            Entity-360
          </Button>
        )}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
        {summary.typeKey && (
          <Tag bordered={false} title={`Type ${summary.typeKey}`}>
            {summary.typeKey}
          </Tag>
        )}
        <EntityStatusChip status={summary.status} />
      </div>
    </div>
  );
}
